import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = ["menu", "button", "icon"]

  connect() {
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
  }

  disconnect() {
    document.removeEventListener('click', this.handleOutsideClick)
  }

  toggle(event) {
    event.stopPropagation()

    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    // Close all other dropdowns before opening this one
    this.closeOtherDropdowns()

    this.menuTarget.classList.remove("hidden")
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute('aria-expanded', 'true')
    }
    if (this.hasIconTarget) {
      this.iconTarget.classList.add('rotate-180')
    }

    // Position submenu intelligently to avoid overflow
    this.positionSubmenu()

    // Add event listener on next tick to avoid immediate triggering from the same click
    requestAnimationFrame(() => {
      document.addEventListener('click', this.handleOutsideClick)
    })
  }

  positionSubmenu() {
    // Check if this is a nested submenu (has left-full class)
    if (!this.menuTarget.classList.contains('left-full')) return

    const menuRect = this.menuTarget.getBoundingClientRect()
    const viewportWidth = window.innerWidth

    // Check if menu would overflow on the right
    if (menuRect.right > viewportWidth) {
      // Position to the left instead
      this.menuTarget.classList.remove('left-full', 'ml-1')
      this.menuTarget.classList.add('right-full', 'mr-1')
    }
  }

  closeOtherDropdowns() {
    // Find all dropdown menus and close them, but only siblings (not parents or children)
    const allMenus = document.querySelectorAll('[data-dropdown-target="menu"]')

    allMenus.forEach(menu => {
      // Skip our own menu
      if (menu === this.menuTarget) return

      const menuDropdown = menu.closest('[data-controller*="dropdown"]')

      // Don't close if it's a parent dropdown (this.element is inside it)
      if (menuDropdown && menuDropdown.contains(this.element)) return

      // Don't close if it's a child dropdown (it's inside this.element)
      if (this.element.contains(menu)) return

      // Close sibling dropdowns
      if (!menu.classList.contains('hidden')) {
        menu.classList.add('hidden')

        // Also update the button and icon states
        if (menuDropdown) {
          const button = menuDropdown.querySelector('[data-dropdown-target="button"]')
          const icon = menuDropdown.querySelector('[data-dropdown-target="icon"]')

          if (button) {
            button.setAttribute('aria-expanded', 'false')
          }
          if (icon) {
            icon.classList.remove('rotate-180')
          }
        }
      }
    })
  }

  close() {
    this.menuTarget.classList.add("hidden")
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute('aria-expanded', 'false')
    }
    if (this.hasIconTarget) {
      this.iconTarget.classList.remove('rotate-180')
    }
    document.removeEventListener('click', this.handleOutsideClick)
  }

  handleOutsideClick(event) {
    // Don't close if clicking on a nested dropdown button
    const clickedButton = event.target.closest('[data-dropdown-target="button"]')
    if (clickedButton && clickedButton !== this.buttonTarget) {
      // Clicking on a different dropdown button, let that dropdown handle it
      return
    }

    // Close menu if click is outside dropdown
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }
}
